import { useState, useEffect, useRef, useMemo } from "react";
import Modal from "react-modal";
import useMediaQueryHook from "@hooks/useMediaQueryHook";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader.jsx";
import rightImage from "@assets/images/RightChangedImage.png";
import AlertDialog from "@components/ui/ConfirmDialogue.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BannerImage from "@assets/images/planeerBanner.png";
import { ChevronLeft } from "lucide-react";
import dayjs from "dayjs";
import SnacksDetails from "@features/diet/WeeklyMealPlaner/SnacksDetails.jsx";
import NotFound from "@components/ui/NotFound.jsx";
import { initialSelectMealList } from "data/dietPlanConst.js/index.js";
import ExcercisePlanLoader from "@components/ui/Loaders/ExcercisePlanLoader.jsx";
import { ReactComponent as LunchTime } from "@assets/images/LunchTime.svg";
import { ReactComponent as SnackTime } from "@assets/images/image 259.svg";
import leftImage from "@assets/images/LeftImage.png";
import { useDispatch, useSelector } from "react-redux";
import { resetAllMealsToShow } from "Redux/slices/selectedMealsSlice.js";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader.jsx";
import { useTranslation } from "react-i18next";
import { getPlan, rejectDietPlan, saveSelectedDietPlan } from "api/dietPlan.js";
import WeeklyMealSelection from "@features/diet/WeeklyMealSelection/index.js";
import MealSection from "@features/diet/WeeklyMealSelection/MealSection.jsx";
const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
const WeeklyMealPlanner = () => {
  const location = useLocation();
  const { daySelected = "" } = location.state || {};
  const navigate = useNavigate();
  const { t } = useTranslation();

  // const mealsToShow = useSelector((state) => state.selectedMeals.mealToShow);
  const [firstLoad, setFirstLoad] = useState(true);

  const [tab, setTab] = useState("Meals");
  const [mealList, setMealList] = useState(null);
  const { isMobile } = useMediaQueryHook();
  const [selectedDay, setSelectedDay] = useState(daySelected);

  const [sortedAvailableDays, setSortedAvailableDays] = useState(null);
  const mealTypes = ["Breakfast", "Lunch", "Dinner"];
  const [selectedMeals, setSelectedMeals] = useState({});
  const [loadingMeals, setLoadingMeals] = useState({});
  const [globalLoading, setGlobalLoading] = useState(false);
  const { planStartDate, setPlanStartDate } = useState(null);
  const [date, setDate] = useState(null);
  const startDate = new Date(planStartDate);
  const daysToSort = Array.from({ length: 7 }, (_, i) => {
    const currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + i);
    return {
      day: currentDate.toLocaleDateString("en-US", { weekday: "long" }),
    };
  });
  const [countdown, setCountdown] = useState(0);
  const countdownRef = useRef(null);
  const timeoutRef = useRef(null);
  const isMountedRef = useRef(true);

  const startCountdown = (time) => {
    setCountdown(time);
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 0) {
          clearInterval(countdownRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const extractAllImages = (dayImages) => {
    const snacks = dayImages?.Snacks || {};

    const result = {
      Breakfast: dayImages?.Meals?.Breakfast || [],
      Lunch: dayImages?.Meals?.Lunch || [],
      Dinner: dayImages?.Meals?.Dinner || [],
      afternoon_snacks: snacks["Afternoon Snacks"] || null,
      evening_snacks: snacks["Evening Snacks"] || null,
    };

    return result;
  };

  const orderDaysGet = (CommingDate) => {
    return Array.from({ length: 7 }, (_, i) => {
      const currentDate = new Date(CommingDate);
      currentDate.setDate(currentDate.getDate() + i);
      return {
        day: currentDate.toLocaleDateString("en-US", { weekday: "long" }),
      };
    });
  };

  const handleSetDietPlan = (data) => {
    if (data?.diet_plan) {
      const diet_plan = data?.diet_plan;

      const planStartDate = data?.plan_start_date;
      // const dayOrder = daysToSort.map((item) => item.day);
      const dayOrder = orderDaysGet(planStartDate);

      const dayOrderStrings = dayOrder.map((item) => item.day);

      const dietPlan = Object.fromEntries(
        Object.entries(diet_plan).sort((a, b) => {
          const indexA = dayOrderStrings.indexOf(a[0]);
          const indexB = dayOrderStrings.indexOf(b[0]);
          return indexA - indexB;
        })
      );

      // const dayOrder = daysToSort.map((item) => item.day);

      // const dietPlan = Object.fromEntries(
      //   Object.entries(diet_plan).sort((a, b) => {
      //     const indexA = dayOrder.indexOf(a[0]);
      //     const indexB = dayOrder.indexOf(b[0]);
      //     return indexA - indexB;
      //   })
      // );
      const images = data?.images || [];
      const updatedMealList = Object.keys(dietPlan)?.map((day, index) => {
        // const meals = extractAllMeals(dietPlan[day].Meals);

        const imageSet = extractAllImages(images[day]);
        const date = dietPlan[day].Date;
        const dayData = dietPlan[day];
        const snacks = dayData?.Snacks;
        return {
          day: day,
          date: date,
          meal: dietPlan[day].Meals ?? "No Meal",
          images: imageSet ?? {},
          color: index % 2 === 0 ? "bg-pink-500" : "bg-blue-500",
          snacks: {
            afternoon_snacks: snacks["Afternoon Snacks"]
              ? snacks["Afternoon Snacks"]
              : null,
            evening_snacks: snacks["Evening Snacks"]
              ? snacks["Evening Snacks"]
              : null,
          },
        };
      });

      const sortedMealList = [...updatedMealList].sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setMealList(sortedMealList);
      setSelectedMeals(
        data?.selected_diet_plan.selectedMeals ?? initialSelectMealList
      );

      if (firstLoad) {
        const AvailableDays = sortedMealList?.map((meal) => meal.day);
        setSortedAvailableDays(AvailableDays);
      }
      setPlanStartDate(data?.plan_start_date);
    }
  };
  // const selectedMeal = mealList?.find((meal) => meal.day === selectedDay);
  const selectedMeal = mealList?.find((meal) => meal?.day === selectedDay);
  // const filteredData = useMemo(() => {
  //   if (!selectedMeal || !mealsToShow[selectedDay]) return null;

  //   return {
  //     ...selectedMeal,
  //     meal: {
  //       Breakfast: (mealsToShow[selectedDay]?.breakfast || [0])
  //         .map((index) => {
  //           const meal = selectedMeal?.meal?.Breakfast?.[index];
  //           return meal ? { ...meal, originalIndex: index } : null;
  //         })
  //         .filter(Boolean),
  //       Lunch: (mealsToShow[selectedDay]?.lunch || [0])
  //         .map((index) => {
  //           const meal = selectedMeal?.meal?.Lunch?.[index];
  //           return meal ? { ...meal, originalIndex: index } : null;
  //         })
  //         .filter(Boolean),
  //       Dinner: (mealsToShow[selectedDay]?.dinner || [0])
  //         .map((index) => {
  //           const meal = selectedMeal?.meal?.Dinner?.[index];
  //           return meal ? { ...meal, originalIndex: index } : null;
  //         })
  //         .filter(Boolean),
  //     },
  //     images: {
  //       Breakfast: (mealsToShow[selectedDay]?.breakfast || [0])
  //         .map((index) => selectedMeal?.images?.Breakfast?.[index])
  //         .filter(Boolean),
  //       Lunch: (mealsToShow[selectedDay]?.lunch || [0])
  //         .map((index) => selectedMeal?.images?.Lunch?.[index])
  //         .filter(Boolean),
  //       Dinner: (mealsToShow[selectedDay]?.dinner || [0])
  //         .map((index) => selectedMeal?.images?.Dinner?.[index])
  //         .filter(Boolean),
  //     },
  //   };
  // }, [selectedMeal, mealsToShow, selectedDay]);

  const fetchDietPlan = async () => {
    try {
      const data = await getPlan();
      setDate(data?.plan_start_date);
      handleSetDietPlan(data);
    } catch (error) {
      console.error("Error fetching diet plan:", error);
    } finally {
      setFirstLoad(false);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    fetchDietPlan();
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
      isMountedRef.current = false;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
  }, []);

  useEffect(() => {
    if (!location.state) {
      navigate(-1);
    }
  }, [location.state, navigate]);

  const renderMealSection = (mealType) => (
    <MealSection
      mealType={mealType}
      startDate={date}
      selectedMeal={selectedMeal}
      filteredMeal={selectedMeal}
      setSelectedMeals={setSelectedMeals}
      base_url={BASE_URL}
      handleSetDietPlan={handleSetDietPlan}
      selectedIndex={
        selectedMeals?.[selectedMeal?.day]?.[mealType.toLowerCase()] || 0
      }
      timeoutRef={timeoutRef}
      isMountedRef={isMountedRef}
      countdown={countdown}
      countdownRef={countdownRef}
      startCountdown={startCountdown}
      loadingHide={loadingMeals}
      loading={loadingMeals[selectedMeal.day]?.[mealType]}
      onSetLoading={(isLoading) => {
        setLoadingMeals((prev) => {
          const updatedState = {
            ...prev,
            [selectedMeal.day]: {
              ...(prev[selectedMeal.day] || {}),
              [mealType]: isLoading,
            },
          };
          const isAnyMealLoading = Object.values(updatedState).some(
            (day) => day && Object.values(day).some((loading) => loading)
          );

          setGlobalLoading(isAnyMealLoading);

          return updatedState;
        });
      }}
      globalLoading={globalLoading}
      weeklyMealPlanner={true}
    />
  );
  if (location.state) {
    return (
      <>
        {/* <NavigationPrompt when={formSubmitting} mealSelection={true} /> */}
        {firstLoad ? (
          // <ExcercisePlanLoader />
          <ActualDietPlanLoader />
        ) : (
          <div className="bg-white  rounded-[36px]">
            {/* <div className="flex items-center justify-between mb-2 md:mb-[20px]">
              <h2 className="text-2xl font-bold text-black">
                Week list of meal
              </h2>
            </div>
            <div
              className="w-full h-[183px] hidden md:block rounded-[10px]"
              style={{
                backgroundImage: `url(${BannerImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            ></div> */}
            <div
              className="w-full h-[356px] relative block bg-white rounded-[36px]"
              style={{
                backgroundImage: `url(${BannerImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <img
                src={leftImage}
                alt="leftImage"
                className="absolute top-[-2px] -left-[1px] 2xl:top-[-2px] 2xl:left-[-2px] bg-[transparent]  max-w-[260px]"
              />
              <button
                className="absolute cursor-default 
            left-5 
          top-[2%] 
            px-5 py-2 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] 
            text-white rounded-[100px] text-nowrap text-[20px]"
              >
                {t(`weeklyMealDetails.menuDetail`)}
              </button>

              <img
                src={rightImage}
                alt="rightImage"
                className="absolute bottom-[-2px] right-[-1px] max-w-[215px]"
              />
              <button
                onClick={() => navigate(-1)}
                className="absolute bottom-[3%] xl:bottom-[3%] right-[4%] lg:right-[2%] xl:right-[1%] 2xl:right-[1%] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full px-5 py-2 flex items-center text-white gap-2 text-[20px] font-[500] font-[Lato]"
              >
                <ChevronLeft
                  className="w-6 h-6 bg-white rounded-full text-[#0575e6] p-[2px]"
                  strokeWidth={4}
                />
                <span> {t(`weeklyMealDetails.goBack`)}</span>
              </button>
            </div>
            <div className="p-[18px] md:p-[36px]">
              {!isMobile ? (
                <div className="hidden md:flex bg-white rounded-full p-1 border border-[#E9E9E9] w-full gap-0 md:gap-2 my-3 shadow-md">
                  {sortedAvailableDays?.map((day) => (
                    <button
                      key={day}
                      className={`text-[14px] font-[400] font-[Lato] px-3 py-[11px] flex-1 border border-[1px] border-[transparent] ${
                        selectedDay === day
                          ? "text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[100px] "
                          : "text-black hover:border hover:border-[#0575e6] hover:text-[#0575e6] rounded-[100px]"
                      }`}
                      onClick={() => setSelectedDay(day)}
                    >
                      {/* {day} */}
                      {t(`days.${day.toLowerCase()}`)}
                    </button>
                  ))}
                </div>
              ) : (
                <div className="flex items-center rounded-[8px] gap-1 w-full border border-[2px] border-[#F2F2F2B8] overflow-x-auto">
                  {sortedAvailableDays?.map((day, index) => {
                    return (
                      <div
                        key={index}
                        className={`flex flex-col flex-1 rounded-md !py-[28px] !px-[5px] cursor-pointer border border-white gap-[10px] ${
                          selectedDay === day &&
                          "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white "
                        }`}
                        onClick={() => setSelectedDay(day)}
                      >
                        <p
                          className={`text-[14px] font-[Lato] ${
                            selectedDay === day && "text-white"
                          }  font-[400] text-center`}
                        >
                          {/* {item?.day} */}
                          {t(
                            `dietPlanDashboard.allMeals.daysShort.${day?.slice(
                              0,
                              3
                            )}`
                          )}
                        </p>
                        {/* <p className="text-[14px] font-[Lato] text-center">
                        {item?.date}
                      </p> */}
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="flex justify-center items-center m-2 md:my-[32px] gap-2 md:gap-5 text-[14px] md:text-[16px] font-[Lato]">
                {/* bg-blue-600  text-white */}
                <button
                  className={`px-2 md:px-5 py-1 border border-gray-300  rounded-[8px] flex gap-2 items-center ${
                    tab === "Meals"
                      ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)]  text-white"
                      : " hover:border-[#0575e6] hover:text-[#0575e6]"
                  }`}
                  onClick={() => setTab("Meals")}
                >
                  <LunchTime />
                  {t(`weeklyMealDetails.mealTabName`)}
                </button>
                <button
                  className={`px-2 md:px-5 py-1 border border-gray-300  rounded-[8px] flex gap-2 items-center ${
                    tab === "Snacks"
                      ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)]  text-white"
                      : " hover:border-[#0575e6] hover:text-[#0575e6]"
                  }`}
                  onClick={() => setTab("Snacks")}
                >
                  <SnackTime />
                  {t(`weeklyMealDetails.snacksTabName`)}
                </button>
              </div>
              {tab === "Meals" ? (
                selectedMeal ? (
                  <div className="space-y-[12px]">
                    {mealTypes.map((type) => renderMealSection(type))}
                  </div>
                ) : (
                  <NotFound message={`No meal found for ${selectedDay}.`} />
                )
              ) : selectedMeal?.snacks?.afternoon_snacks ||
                selectedMeal?.snacks?.evening_snacks ? (
                <div className="space-y-0">
                  <SnacksDetails
                    mealType="Afternoon Snacks"
                    meal={selectedMeal.snacks.afternoon_snacks}
                    selectedMeal={selectedMeal}
                    mealKey="afternoon_snacks"
                    mealSelection={true}
                  />
                  <SnacksDetails
                    mealType="Evening Snacks"
                    meal={selectedMeal.snacks.evening_snacks}
                    selectedMeal={selectedMeal}
                    mealKey="evening_snacks"
                    mealSelection={true}
                  />
                </div>
              ) : (
                <NotFound message="No Snacks Found" />
              )}
            </div>
          </div>
        )}
      </>
    );
  }
};

export default WeeklyMealPlanner;
